import React from 'react';
import { useTranslation } from 'react-i18next';
import LandingNavbar from '../components/LandingNavbar';

const PricingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-100">
      <LandingNavbar />
      
      {/* Pricing Content */}
      <section className="py-20 px-4 md:px-8 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            {t('pricing.title', 'Pricing')}
          </h1>
        </div>
        
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <p className="text-lg text-gray-700 mb-6">
            {t('pricing.earlyAccessDescription')}
          </p>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <p className="text-blue-700">
              {t('pricing.freeUntilStable')}
            </p>
          </div>
        </div>
      </section>
      
      {/* Footer - Same as Landing Page */}
      <footer className="py-8 px-4 md:px-8 bg-gray-800 text-white mt-auto">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('landing.footer.about', 'About School Menus')}</h3>
            <p className="text-gray-400">
              {t('landing.footer.aboutText', 'A platform designed to simplify the creation, translation, and publication of school lunch menus.')}
            </p>
          </div>
          
          {/* Placeholder Column 1 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-800 pointer-events-none select-none">.</h3>
            <ul className="space-y-2">
              <li>&nbsp;</li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('landing.footer.legal', 'Legal')}</h3>
            <ul className="space-y-2">
              <li><a href="/terms" className="text-gray-400 hover:text-white transition-colors">{t('landing.footer.terms', 'Terms & Conditions')}</a></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('landing.footer.contact', 'Contact')}</h3>
            <p className="text-gray-400">{t('landing.footer.email', 'info@schoolmenus.xyz')}</p>
          </div>
        </div>
        
        <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} School Menus. {t('landing.footer.rights', 'All rights reserved.')}</p>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage; 